/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import PropTypes, { string } from 'prop-types';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import moment from 'moment';
import { PAYMENT_MODE_TYPES_LIST, PRODUCT_CATEGORY_TYPES, RC_TRANSFERRED_BY_TYPES, RC_TRANSFERRED_BY_TYPES_LIST, RC_TYPES_LIST } from 'src/containers/product-container/ProductConstants';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import FormikInput from 'src/components/formik/FormikInput';
import CompanyDropDown from 'src/business-components/CompanyDropDown';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikToggle from 'src/components/formik/FormikToggle';
import { crossSaleSearchAction } from 'src/containers/cross-sale-container/actions/CrossSaleActions';
import ProductDropDown from 'src/business-components/ProductDropDown';
import FormikRadio from 'src/components/formik/FormikRadio';
import {
    crossSaleSearchAPI,

} from 'src/api/CrossSaleApi';
import UserDropDown from 'src/business-components/UserDropDown';

function RTOVehileForm({ values }) {
    // REDUX
    const dispatch = useDispatch();
    const {
        // search: {
        //     data: searchResults,
        // },
        refId
    } = useSelector((state) => state.CrossSaleReducer, shallowEqual);

    // const {
    //     search: {
    //         data: searchResults,

    //     },
    // } = useSelector((state) => state.CaseReducer, shallowEqual);

    useEffect(() => {
        //=== disbursed Amount calc
        const loanAmt = values.meta.loanAmount || 0;
        const pf = values.meta.processingFees || 0;
        const EMIAmt = values.meta.EMIAmount || 0;
        const EMIAdvance = (values.meta.EMIAdvance || 0) * EMIAmt;
        const crossAmt = values.meta.crossSaleAmount || 0;
        // const FinalAmt = (loanAmt - pf - EMIAdvance - crossAmt);
        const FinalAmt = (loanAmt - pf - EMIAdvance);
        values.meta.disbursedAmount = (FinalAmt > 0) ? FinalAmt : 0;
        //=== disbursed Amount calc

        //==Last EMI Date
        // const advEMI = (values.meta.EMIAdvance > 0) ? values.meta.EMIAdvance : 0;
        // const tenure = (values.meta.tenure > 0) ? (values.meta.tenure - parseInt(advEMI)) : 0;
        // const tenure = (values.meta.tenure > 0) ? (values.meta.tenure - (parseInt(advEMI) + 1)) : 0;
        // const firstEMAI = moment(values.meta.firstEMI).format("DD-MMM-YYYY")
        // const lastEMIDate = moment(firstEMAI).add(tenure, 'months');
        // values.meta.LastEMIDate = moment(lastEMIDate).format("DD-MMM-YYYY");
        // values.meta.grossLoanAmount = (parseInt(loanAmt) + parseInt(crossAmt));
        //==Last EMI Date


    }, [values.meta])


    useEffect(() => {
        const loadCrossSaleTotal = async () => {
            if (!values._id) return;

            let where = {
                refId: values._id,
                deleted: false,
                source: 'case'
            };

            const {
                data: {
                    data: crossSale,
                },
            } = await crossSaleSearchAPI({
                where,
                sortBy: 'ts',
                pageLength: 0,
                currentPage: 1,
                autopopulate: false,
            });
            var totalCrossSale = crossSale.data.reduce(function (tot, cross) {
                return tot + cross.amount;
            }, 0);
            values.meta.crossSaleAmount = totalCrossSale

        }
        loadCrossSaleTotal();
    }, [values.meta])

    useEffect(() => {
        const docSent = values?.RTOVechile?.docSentDate;
        const parivahanOk = values?.RTOVechile?.parivahanOkDate;

        if (!values.RTOVechile) {
            values.RTOVechile = {};
        }

        if (docSent && parivahanOk) {
            const sentDate = moment(docSent);
            const okDate = moment(parivahanOk);
            const diffDays = okDate.diff(sentDate, 'days');

            values.RTOVechile.daysDiffDocSendDParivhanOkD = diffDays >= 0 ? diffDays : 0;
        } else {
            values.RTOVechile.daysDiffDocSendDParivhanOkD = 0;
        }
    }, [values?.RTOVechile?.docSentDate, values?.RTOVechile?.parivahanOkDate]);

    return (
        <>
            <div className="mt-3">
                <h3>
                    Vehicle Information
                </h3>
                <div className="form-row">
                    <div className="form-group col-md-3">
                        <label>Vehicle Name</label>
                        <ProductDropDown
                            name="meta.vehicleProductId"
                            value={values?.meta?.vehicleProductId || ''}
                            productCategory={PRODUCT_CATEGORY_TYPES.VEHICLE}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Vehicle Number</label>
                        <FormikInput
                            name="meta.vehicleNumber"
                            type="text"
                            className="form-control"
                        />
                    </div>

                    <div className="form-group col-md-3">
                        <label>Mfg Year</label>
                        <FormikInput
                            name="meta.vehicleModelYear"
                            type="text"
                            className="form-control"
                        />

                    </div>

                    <div className="form-group col-md-3">
                        <label>Engine Number</label>
                        <FormikInput
                            name="meta.engineNumber"
                            type="text"
                            className="form-control"
                        />
                    </div>

                    <div className="form-group col-md-3">
                        <label>Chasis Number</label>
                        <FormikInput
                            name="meta.chasisNumber"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Cost of Asset</label>
                        <FormikInput
                            name="meta.costOfAsset"
                            type="text"
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <h3>
                    RTO Information
                </h3>
                <div className="form-row">

                    <div className="form-group col-md-3">
                        <label>Document Received Date</label>
                        <FormikDateTimePicker
                            name="RTOVechile.docRecvDate"
                            value={values?.RTOVechile?.docRecvDate || ''}
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Document Sent Date</label>
                        <FormikDateTimePicker
                            name="RTOVechile.docSentDate"
                            value={values?.RTOVechile?.docSentDate || ''}
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>RTO Received Date</label>
                        <FormikDateTimePicker
                            name="RTOVechile.rtoRecvDate"
                            value={values?.RTOVechile?.rtoRecvDate || ''}
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Parivahan OK Date</label>
                        <FormikDateTimePicker
                            name="RTOVechile.parivahanOkDate"
                            value={values?.RTOVechile?.parivahanOkDate || ''}
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Work on RC</label>
                        <FormikSelect
                            items={RC_TYPES_LIST}
                            name="RTOVechile.workOnRC"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>RTO Agent Name</label>
                        <UserDropDown
                            name="rtoAgentId"
                            value={values?.RTOVechile?.rtoAgentId || ''}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>RTO Agent Charges</label>
                        <FormikInput
                            name="RTOVechile.rtoAgentCharges"
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Mode of Payment Recv</label>
                        <FormikSelect
                            items={PAYMENT_MODE_TYPES_LIST}
                            name="modeOfPaymentRecv"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>DSA Charges</label>
                        <FormikInput
                            name="RTOVechile.dsaCharges"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Received by DSA</label>
                        <FormikInput
                            name="RTOVechile.recvByDSA"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Mode of Payment Paid</label>
                        <FormikSelect
                            items={PAYMENT_MODE_TYPES_LIST}
                            name="modeOfPaymentPaid"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Bank Name (HPT)(Ex Financer)</label>
                        <FormikInput
                            name="RTOVechile.bankNameExFinancer"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Bank Name (HPA) (New Financer)</label>
                        <FormikInput
                            name="RTOVechile.bankNameNewFinancer"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    {/* <div className="form-group col-md-3">
                        <label>Remarks</label>
                        <FormikInput
                            name="RTOVechile.remarks"
                            type="text"
                            className="form-control"
                        />
                    </div> */}
                    <div className="form-group col-md-3">
                        <label>Charges Remarks</label>
                        <FormikInput
                            name="RTOVechile.chargesRemarks"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Document For InterState</label>
                        <FormikInput
                            name="RTOVechile.docForInterState"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>LIC Amount Recd</label>
                        <FormikInput
                            name="RTOVechile.licAmountRec"
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>LIC Done By</label>
                        <FormikInput
                            name="RTOVechile.licDoneBy"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>No Of Days Btween Doc's Send Date & Parivahan Ok Date</label>
                        <FormikInput
                            name="RTOVechile.daysDiffDocSendDParivhanOkD"
                            type="text"
                            className="form-control"
                        // readOnly={true}
                        />
                    </div>
                    <div style={{ height: '1px', backgroundColor: '#dadfe3', width: '100%', margin: '20px 0' }} />
                    <div className="form-group col-md-3">
                        <label>New RC Recv Date</label>
                        <FormikDateTimePicker
                            name="RTOVechile.newRCReceiveDate"
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Receiving Remarks(Autonet)</label>
                        <FormikInput
                            name="RTOVechile.receivingRemarks"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>New RC Send Date</label>
                        <FormikDateTimePicker
                            name="RTOVechile.newRCSendDate"
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>
                     <div className="form-group col-md-3">
                        <label>Sender's Name</label>
                        <FormikInput
                            name="RTOVechile.sendersName"
                            type="text"
                            className="form-control"
                        />
                    </div>

                     <div className="form-group col-md-3">
                        <label>Sender's No.</label>
                        <FormikInput
                            name="RTOVechile.sendersNo"
                            type="number"
                            className="form-control"
                        />
                    </div>

                    <div style={{ height: '1px', backgroundColor: '#dadfe3', width: '100%', margin: '20px 0' }} />
                    <div className="form-row">
                        <div className="form-group col">
                            <label className="col-md-12">Cust. Presence Status ?</label>
                            <FormikToggle
                                name="RTOVechile.custPresStatus"
                                onlabel="Yes to go"
                                offlabel="No to go"
                            />
                        </div>

                        <div className="form-group col">
                            <label className="col-md-12">NOC + Form 35(Ex Financer)?</label>
                            <FormikToggle
                                name="RTOVechile.nocForm35" />
                        </div>

                        <div className="form-group col">
                            <label className="col-md-12">New RC Recd Date & Remarks?</label>
                            <FormikToggle
                                name="RTOVechile.newRcRec" />
                        </div>
                        <div className="form-group col">
                            <label className="col-md-12">New RC Send Date & Remarks?</label>
                            <FormikToggle
                                name="RTOVechile.newRcSend" />
                        </div>
                        <div className="form-group col">
                            <label className="col-md-12">InterState ?</label>
                            <FormikToggle
                                name="RTOVechile.interState" />
                        </div>
                        <div className="form-group col">
                            <label className="col-md-12">DOE CASE 3C,5C,9C,12C ?</label>
                            <FormikToggle
                                name="RTOVechile.DoeCase" />
                        </div>
                        <div className="form-group col">
                            <label className="col-md-12">Parivahan status ?</label>
                            <FormikToggle name="meta.parivahanStatus" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

RTOVehileForm.propTypes = {
    values: PropTypes.shape({
        meta: PropTypes.shape({
            vehicleProductId: PropTypes.string,
            vehicleModelYear: PropTypes.string,
            vehicleNumber: PropTypes.string,
            engineNumber: PropTypes.string,
            chasisNumber: PropTypes.string,
            // showroomDealer: PropTypes.string,
            // tenure: PropTypes.number,
            // loanAmount: PropTypes.number,
            // disbursedAmount: PropTypes.number,
            // firstEMI: PropTypes.string,
            // EMIAmount: PropTypes.string,
            // LastEMIDate: PropTypes.string,
        }),
        RTOVechile: PropTypes.shape({
            // docRecvDate: PropTypes.Date,
            // docSentDate: PropTypes.date,
            // rtoRecvDate: PropTypes.date,
            workOnRC: PropTypes.string,
            rtoAgentCharges: PropTypes.number,
            dsaCharges: PropTypes.number,
            recvByDSA: PropTypes.number,

        })

    }),
};

RTOVehileForm.defaultProps = {
    values: {
        meta: {
            vehicleNumber: '',
        }
    },
};

export default RTOVehileForm;
